const projectData = [
  // {
  //   id: 0,
  //   title: "Internship: Astros",
  //   categories: ["ui/ux design", "web development"],
  //   description:
  //     "I worked as a UI/UX design intern on the Houston Astros' internal website with a team of 7 developers, Summer 2023. I designed and built data analysis tools for scouts, analysts, performance scientists, and coaches.",
  //   alt: "Houston Astros logo",
  //   path: "astros",
  //   category: "Internship",
  //   duration: "Jun - Aug 2023",
  // },
  // {
  //   id: 0,
  //   project: "mochi",
  //   path: "",
  //   title: "Mochi Health: Humanizing Telemedicine",
  //   categories: ["ui/ux design"],
  //   description:
  //     "Designing healthcare products for patients and doctors, rebranding the Mochi marketing website, and building Bento Design System. Coming soon!",
  //   alt: "Screenshot of joinmochi.com, which I designed.",
  //   category: "Product Design, UI/UX",
  //   team: "Mochi Design Team + me",
  //   duration: "Mar 2024 - Present",
  // },
  {
    id: 0,
    project: "mochi",
    path: "mochi-health",
    protected: true,
    title: "Mochi Health: Bento Design System",
    description:
      "Mochi Health's design system, which now supports a platform serving over 100,000 patients.",
    alt: "Preview of design system components",
    tags: ["2025", "Design systems", "shipped!"],
    team: "Stacia Seetoh + me",
    duration: "Dec 2024 - Mar 2025",
  },
  {
    id: 1,
    project: "blooms",
    title: "Blooms",
    tags: ["2024", "Web dev", "design research", "shipped!"],
    description:
      "An interactive web app that visualizes global data to highlight women's shared challenges and destigmatize abortion.",
    alt: "Screenshot of web app: a blue globe and statistics",
    path: "blooms",
    team: "Just me!",
    duration: "Oct 2024",
    tldr: "tldr",
  },
  {
    id: 2,
    project: "a11y",
    path: "a11y-buddy",
    title: "A11y Buddy For VSCode",
    tags: ["2024", "Web dev", "product design", "shipped!"],
    description:
      "A VSCode extension pet care game designed to encourage web developers to proactively implement web accessibility.",
    alt: "A11y Buddy screenshot",
    team: "Anna Ohrt + me",
    duration: "Nov 2023 - May 2024",
  },

  {
    id: 3,
    project: "eto",
    title: "Eat the Ocean",
    tags: ["2023", "Product design"],
    description:
      "A bycatch seafood recipe app designed to reduce waste in the New England fishing industry through awareness and education.",
    alt: "Three screenshotted previews of Eat the Ocean app.",
    path: "eat-the-ocean",
    team: "Just me!",
    duration: "Feb - May 2023",
  },
  // {
  //   id: 4,
  //   project: "collab",
  //   title: "Collab @ RISD",
  //   categories: ["design strategy", "graphic design"],
  //   description:
  //     "A campus-wide series of events and a digital archive to increase interdisciplinary collaboration at RISD and Brown University.",
  //   alt: "Posters, profile cards, Instagram posts, and prompt cards I designed for this project.",
  //   path: "collab-risd",
  //   category: "Design strategy, UX research, graphic design",
  //   team: "Yi Kang Sun, Jimmy Zhong, Ke Xu, Jenny Du, + me",
  //   duration: "Feb - May 2023",
  //   tldr: "This project was a semester-long Collaborative Study Project, during which a group of 4 other industrial and graphic designers and I sought to increase interdisciplinary collaboration at RISD. Over the course of four months, we designed, tested, and implemented two solutions:",
  // },
  // {
  //     id: 3,
  //     title: 'experiments in p5.js',
  //     thumbnail: '/imgs/eattheoceanthumb.png',
  //     type: 'Creative Coding',
  //     description: 'First time creative coding!',
  //     path: 'p5js',
  //     category: 'Individual Project',
  //     duration: 'May 2023 (3 wks)',
  //     tldr: 'My first time using p5.js, in these creative coding experiemntes, I played with color, line, transparency, and mouse interactivity to create meditative experiences.',
  //     button: true
  // },

  // {
  //   id: 5,
  //   title: "guo sweets",
  //   categories: ["graphic design", "illustration"],
  //   description:
  //     "Recipes for my favorite homemade desserts made by my mom compiled into a zine; a documentation of family memory and culture.",
  //   alt: "First two pages of the Guo Sweets zine.",
  //   path: "guo-sweets",
  //   category: "Individual Project",
  //   duration: "Dec - Jan 2022",
  // },
  // {
  //   id: 6,
  //   title: "AstroBunny",
  //   categories: ["design strategy", "game development"],
  //   description:
  //     'My research into the relationship between femininity, gender, and shame in video games. AstroBunny is a "feminine" endless shooter game I created in response to my research in order to test my theories with players.',
  //   alt: "AstroBunny screenshots: start, game, and end screen.",
  //   path: "astrobunny",
  //   category: "Individual Projects",
  //   duration: "Sep - Dec 2023",
  // },
  // {
  //   id: 7,
  //   title: "Pair",
  //   categories: ["design strategy", "graphic design"],
  //   description:
  //     "A pair of devices that aids people medical adherence. Submitted to Stanford Life Transition Design Challenge.",
  //   alt: "Rendering of Pair.",
  //   path: "pair",
  //   category: "Group Project",
  //   team: "Deelia Wang, Jasmine Lee, Riya Kesari, and me",
  //   duration: "Nov - Dec 2023",
  // },
];

export default projectData;
